/**
 * Off-road recovery tier options (Policy extras) — values match Entsia / API amounts.
 */
export const OFF_ROAD_RECOVERY_OPTIONS = [
  {
    value: '1500',
    label: 'Up to $1,500',
    description:
      'Base cover for recovery when your vehicle is stuck beyond where a typical 2WD can reach.',
  },
  {
    value: '5000',
    label: 'Up to $5,000',
    description: 'Higher cover limit for more involved recovery in remote or difficult access areas.',
  },
  {
    value: '15000',
    label: 'Up to $15,000',
    description: 'Substantial cover for specialist recovery in challenging off-road situations.',
  },
  {
    value: '30000',
    label: 'Up to $30,000',
    description: 'Maximum tier for extensive recovery costs on very remote or complex recoveries.',
  },
] as const

export type OffRoadRecoveryOption = (typeof OFF_ROAD_RECOVERY_OPTIONS)[number]

export function mapOffRoadRecoveryToOption(apiValue: string | number | null | undefined): string {
  if (apiValue == null || (typeof apiValue !== 'string' && typeof apiValue !== 'number')) return '1500'
  const raw = String(apiValue).trim()
  if (/^[+-]/.test(raw)) return '1500'
  const digits = raw.replace(/\D/g, '')
  const amount = digits ? parseInt(digits, 10) : NaN
  if (isNaN(amount) || amount <= 0) return '1500'
  const match = OFF_ROAD_RECOVERY_OPTIONS.find((opt) => parseInt(opt.value, 10) === amount)
  return match?.value ?? '1500'
}
